import { router } from '../router'
import authRepository from '../repositories/auth.repository'
import clientsRepository from '../repositories/clients.repository'
import vigilanceRepository from '../repositories/vigilance.repository'
import notebookRepository from '../repositories/notebook.repository'
import * as actionTypes from './actionTypes'
import * as commitTypes from './commitTypes'
import months from './months'
import positionsRepository from '../repositories/positions.repository'
import vehiclesRepository from '../repositories/vehicles.repository'
import comunitcationsRepository from '../repositories/comunications.repository'
import localizationRepository from '../repositories/localizationRepository'
import toolsRepository from '../repositories/tools.repository'
import usersRepository from '../repositories/users.repository'
import structuresRepository from '../repositories/structures.repository'
import petitionsRepository from '../repositories/petitions.repository'
import itemsRepository from '../repositories/items.repository'
import securityRepository from '../repositories/security.repository'
import { event } from 'vue-analytics'
import peopleRepository from '../repositories/people.repository'
import arlsRepository from '../repositories/arls.repository'
import { statelocalstorage } from '../utils/statelocalstoreage'

export const actions = {
    loadCompany({ commit, dispatch }, payload) {
        return new Promise((resolve, reject) => {
            clientsRepository
                .getClient(payload.slug)
                .then(client => {
                    dispatch('setClient', client)
                    //dispatch('persistState');
                    resolve(client)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    setClient({ commit, dispatch }, client) {
        commit('client', client)
        // !!client && dispatch('openClientChannel');
        // !!client && dispatch('loadPendingMail');
    },
    login({ state, commit, dispatch }, payload) {
        localStorage.clear()
        return new Promise((resolve, reject) => {
            authRepository
                .authenticate(
                    payload.user,
                    payload.pass,
                    payload.companySlug,
                    payload.vigilanceAccess
                )
                .then(data => {
                    // Si el estado es falso es porque estan mal las credenciales
                    if (!data.status) {
                        reject(data.msg)
                        return
                    }

                    const user = data.user
                    commit('user', user)
                    commit('assignedClients', data.assignedClients)
                    commit('otherClients', data.otherClients)
                    commit('setMenuOptions', data.menuOptions)

                    // Evento para google analytics
                    event('core', 'login', user.username)

                    // dispatch(actionTypes.LOAD_CLIENTS);
                    // dispatch(actionTypes.LOAD_VALID_YEARS);
                    // dispatch(actionTypes.LOAD_MONTHS);
                    // dispatch(actionTypes.LOAD_POSITIONS);
                    // dispatch(actionTypes.LOAD_ANNOTATION_TYPES);

                    if (data.user.profile.request_client_on_creation) {
                        commit('client', data.user.clients[0])
                        commit('structures', data.structures)
                    }

                    if (data.user.profile.slug === 'supervisor') {
                        commit(commitTypes.SET_SUPERVISOR, data.user)
                    }

                    dispatch(
                        actionTypes.LOAD_ALERT_NOTIFICATIONS,
                        user.profile.slug
                    ).then(() => {
                        resolve(data)
                    })
                })
                .catch(error => {
                    toastr.error('Error de autenticación')
                    reject(error)
                })
        })
    },
    logOut({ state, commit, dispatch }) {
        commit('user', null)
        dispatch('setClient', null)

        // Limpiar el estado de la aplicacion
        let newStatus = Object.assign({}, state)
        Object.keys(newStatus).map(
            key => (newStatus[key] = Array.isArray(newStatus[key]) ? [] : null)
        )
        commit('state', newStatus)

        localStorage.clear()

        if (router.history.current.name !== 'loginPage') {
            router.push({
                name: 'loginPage',
            })
        }
    },
    autoLogin({ state, commit, dispatch }) {
        const strState = localStorage.getItem('state')
        // let theState = !!strState? JSON.parse(LZString.decompress(strState)): null;
        let theState = !!strState ? JSON.parse(strState) : null
        if (!!theState) {
            commit('state', theState)
        } else {
            dispatch('logOut')
        }
    },
    persistState({ state }) {
        // localStorage.setItem('state', LZString.compress(JSON.stringify(state)));
        statelocalstorage(state)
    },
    entries({ state, commit, dispatch }) {
        return new Promise((resolve, reject) => {
            vigilanceRepository
                .getEntries(state.client.id)
                .then(data => {
                    commit('personEntries', data.personEntries)
                    commit('vehicleEntries', data.vehicleEntries)
                    resolve(data)
                })
                .catch(error => {
                    toastr.error('Ocurrió un error al cargar los ingresos')
                    reject(error)
                })
        })
    },
    alarms({ state, commit, dispatch }) {},
    reportEntryAlarm({ state, commit }, alarm) {
        // Reportar las alarmas que no hayan sido persistidas
        // let entry = state.entries.find(entry => entry.id === alarm.data.id);
        let entry = alarm.data

        // Validar si la alarma por ingreso ya fue reportada para no crear registros duplicados
        if (!!entry.alarmed) return

        vigilanceRepository
            .reportAlarm(alarm)
            .then(data => {
                commit('setAlarmedEntry', entry)
            })
            .catch(error =>
                toastr.error('Ocurrió un error al reportar las alarmas')
            )
    },
    notes1({ state, commit, dispatch }, payload) {
        return new Promise((resolve, reject) => {
            let notebookRepository1 = {
                ...notebookRepository,
            }
            notebookRepository1
                .getNotes(payload.clientId)
                .then(data => {
                    commit('notes', data)
                    dispatch('persistState')
                    resolve(data)
                })
                .catch(error => {
                    toastr.error(
                        'Ocurrió un error al consultar las ultimas minutas'
                    )
                    reject(error)
                })
        })
    },
    addPersonEntry({ state, commit }, personEntry) {
        let entries = state.personEntries.slice(0)
        entries.push(personEntry)
        commit('personEntries', entries)
    },
    openClientChannel({ state, dispatch }) {
        // TODO: Revisar si es necesario abrir el canal de echo
        // Echo.channel(`App.Client.${state.client.id}`)
        //     .listen('.NewEntryReported', data => {
        //         dispatch('addPersonEntry', data.personEntry)
        //     })
        //     .listen('.NewDepartureReported', data => {
        //         dispatch('entries')
        //     })
        //     .listen('.NewAlarm', e => {
        //         console.log(e)
        //     })
    },
    loadPendingMail({ state, commit }) {
        let vr = Object.assign({}, vigilanceRepository)
        vr.getPendingMail(state.client.id)
            .then(mail => {
                commit('mail', mail)
            })
            .catch('Ocurrió un error al cargar la correspondencia')
    },
    saveMailDelivery({ state, commit }, item) {
        return new Promise((resolve, reject) => {
            vigilanceRepository
                .saveMailDelivery(state.user.id, item)
                .then(mailDelivery => {
                    const mail = state.mail.slice(0)
                    const index = mail.findIndex(
                        item => item.id === mailDelivery.mail_id
                    )
                    index !== -1 && mail.splice(index, 1)
                    commit('mail', mail)
                    resolve(mailDelivery)
                })
                .catch(error => reject(error))
        })
    },
    registerPersonDeparture({ state, commit }, payload) {
        return new Promise((resolve, reject) => {
            const vr = Object.assign({}, vigilanceRepository)
            vr.savePersonDeparture(
                payload.entryId,
                payload.notes,
                state.user.id
            )
                .then(data => resolve(data))
                .catch(error => reject(error))
        })
    },
    async [actionTypes.LOAD_CLIENTS]({ commit }) {
        const { data } = await repo.get('clients/list')
        commit(commitTypes.SET_CLIENTS, data)
        // const cr = {
        //     ...clientsRepository
        // };
        // cr.getAll()
        //     .then(clients => commit(commitTypes.SET_CLIENTS, clients))
        //     .catch(error => toastr.error('Ocurrió un error al cargar los clientes'));
    },
    [actionTypes.LOAD_VALID_YEARS]({ commit }) {
        const vr = {
            ...vigilanceRepository,
        }

        vr.getValidYears()
            .then(years => {
                const validYears = []
                years.map(year =>
                    validYears.push({
                        id: year,
                        name: year,
                    })
                )
                commit(commitTypes.SET_VALID_YEARS, validYears)
            })
            .catch(error => toastr.error('Ocurrió un error al cargar los años'))
    },
    [actionTypes.LOAD_MONTHS]({ commit }) {
        commit(commitTypes.SET_MONTHS, months)
    },
    [actionTypes.LOAD_POSITIONS]({ state, commit }) {
        const pr = {
            ...positionsRepository,
        }
        pr.getAll()
            .then(data => commit(commitTypes.SET_POSITIONS, data))
            .catch(error =>
                toastr.error('Ocurrió un error al cargar las posiciones')
            )
    },
    [actionTypes.LOAD_VEHICLE_ENTRY_MASTER_DATA]({ commit }) {
        const vr = Object.assign({}, vehiclesRepository)

        vr.getEntryMasterData()
            .then(data => {
                commit(commitTypes.SET_VEHICLE_ENTRY_MASTER_DATA, data)
            })
            .catch(
                'Ocurrió un error al cargar los datos maestros para el ingreso de vehículos'
            )
    },
    [actionTypes.LOAD_VISITOR_TYPES]({ commit }) {
        const vr = {
            ...vigilanceRepository,
        }
        vr.getVisitorTypes()
            .then(data => {
                const visitorTypes = data.filter(
                    item => !!item.selectable && item.group === 'peatonal'
                )
                commit(commitTypes.SET_VISITOR_TYPES, visitorTypes)
            })
            .catch(error =>
                toastr.error('Ocurrió un error al cagar los tipos de visitante')
            )
    },
    [actionTypes.LOAD_PASSENGER_TYPES]({ commit }) {
        const vr = Object.assign({}, vigilanceRepository)
        vr.getVisitorTypesByGroup('vehicular')
            .then(data => commit(commitTypes.SET_PASSENGER_TYPES, data))
            .catch(error =>
                toastr.error('Ocurrió un error al cargar los tipos de pasajero')
            )
    },
    [actionTypes.LOAD_ALERT_NOTIFICATIONS]({ commit }, profileSlug) {
        return new Promise((resolve, reject) => {
            const cr = {
                ...comunitcationsRepository,
            }
            cr.getAlertNotifications(profileSlug)
                .then(data => {
                    commit(commitTypes.SET_ALERT_NOTIFICATIONS, data)
                    resolve(data)
                })
                .catch(reject)
        })
    },
    [actionTypes.LOAD_ANNOTATION_TYPES]({ state, commit }, force = false) {
        if (loaded(state, 'annotationTypes')) return

        const nr = {
            ...notebookRepository,
        }
        nr.getAnnotationTypes()
            .then(data => {
                commit(commitTypes.SET_ANNOTATION_TYPES, data)
            })
            .catch(error =>
                toastr.error(
                    'Ocurrió un error al cargar los tipos de anotaciones en minuta'
                )
            )
    },
    [actionTypes.LOAD_CITIES]({ commit }) {
        const lr = {
            ...localizationRepository,
        }
        lr.getAllCities()
            .then(data => commit(commitTypes.SET_CITIES, data))
            .catch(error =>
                toastr.error('Ocurrió un error al cargar las ciudades')
            )
    },
    [actionTypes.LOAD_VEHICLE_TYPES]({ commit }) {
        const vr = Object.assign({}, vehiclesRepository)
        vr.getTypes()
            .then(data => {
                commit(commitTypes.SET_VEHICLE_TYPES, data)
            })
            .catch(error =>
                toastr.error('Ocurrio un error al cargar los tipos de vehículo')
            )
    },
    [actionTypes.LOAD_CLIENT_TYPES]({ commit }) {
        const cr = {
            ...clientsRepository,
        }
        cr.getClientTypes()
            .then(data => commit(commitTypes.SET_CLIENT_TYPES, data))
            .catch(error =>
                toastr.error('Error al cargar los tipos de clientes')
            )
    },
    [actionTypes.LOAD_IDENTIFICATION_TYPES]({ commit }) {
        let typesRepo = {
            ...clientsRepository,
        }
        typesRepo
            .getIdentificationTypes()
            .then(data => commit(commitTypes.SET_IDENTIFICATION_TYPES, data))
            .catch(error =>
                toastr.error('Error al cargar los tipos de identificación')
            )
    },
    [actionTypes.LOAD_TOOLS]({ commit }) {
        const tr = {
            ...toolsRepository,
        }
        tr.getTools()
            .then(data => commit(commitTypes.SET_TOOLS, data))
            .catch(error => toastr.error('no se pudo cargar las herramientas'))
    },
    [actionTypes.LOAD_PROFILES]({ commit }) {
        const ur = {
            ...usersRepository,
        }
        ur.getProfiles()
            .then(profiles => commit(commitTypes.SET_PROFILES, profiles))
            .catch(error =>
                toastr.error('Ocurrió un error al cargar los perfiles')
            )
    },
    [actionTypes.LOAD_STRUCTURE_TYPES]({ commit }) {
        const sr = {
            ...structuresRepository,
        }
        sr.getStructureTypes()
            .then(data => commit(commitTypes.SET_STRUCTURE_TYPES, data))
            .catch(error => {
                toastr.error(
                    'Ocurrió un error al cargar los tipos de estructuras'
                )
            })
    },
    [actionTypes.LOAD_MAIL_TYPES]({ commit }) {
        const vr = {
            ...vigilanceRepository,
        }
        vr.getMailTypes()
            .then(mailTypes => commit(commitTypes.SET_MAIL_TYPES, mailTypes))
            .catch(error => {
                toastr.error(
                    'Ocurrió un error al cargar los tipos de correspondencia'
                )
            })
    },
    [actionTypes.LOAD_PETITION_TYPES]({ commit }) {
        const pr = Object.assign({}, petitionsRepository)
        pr.loadPetitionTypes()
            .then(data => commit(commitTypes.SET_PETITION_TYPES, data))
            .catch(error =>
                toastr.error('No se pudo cargar los tipos de petición')
            )
    },
    [actionTypes.LOAD_PETITION_STATUSES]({ commit }) {
        const pr = Object.assign({}, petitionsRepository)
        pr.loadPetitionStatuses()
            .then(data => commit(commitTypes.SET_PETITION_STATUSES, data))
            .catch(error =>
                toastr.error('No se pudo cargar los estados de petición')
            )
    },
    [actionTypes.LOAD_ITEM_TYPES]({ commit }) {
        const ir = Object.assign({}, itemsRepository)
        ir.getItemTypes('', 'name', 'asc')
            .then(data => commit(commitTypes.SET_ITEM_TYPES, data))
            .catch(error =>
                toastr.error('Error al cargar los tipos de herramientas')
            )
    },
    [actionTypes.LOAD_ADMINISTRATIVE_USERS]({ commit }) {
        const ur = {
            ...usersRepository,
        }
        ur.getAdministrativeUsers()
            .then(users => commit(commitTypes.SET_ADMINISTRATIVE_USERS, users))
            .catch('Ocurrió un error al cargar los usuarios administrativos')
    },
    async [actionTypes.LOAD_RESTRICTED_VISITORS]({ commit }, clientId) {
        const vr = {
            ...vigilanceRepository,
        }
        try {
            const restrictedVisitors = await vr.loadRestrictedVisitors(clientId)
            commit(commitTypes.SET_RESTRICTED_VISITORS, restrictedVisitors)
        } catch (err) {
            toastr.error(
                'Ocurrió un error cargando los visitantes restringidos'
            )
        }
    },

    async [actionTypes.LOAD_CAPABILITIES]({ commit }) {
        const sr = {
            ...securityRepository,
        }
        const { data } = await sr.getCapabilities()
        commit(commitTypes.SET_CAPABILITIES, data)
    },
    [actionTypes.CLOSE_PERSON_ENTRY]({ state, commit }, personEntryId) {
        const personEntries = state.personEntries
        const index = personEntries.findIndex(item => item.id === personEntryId)

        if (-1 === index) return

        commit('personEntries', personEntries.splice(index, 1))
    },
    async [actionTypes.LOAD_PEOPLE]({ commit }, payload) {
        const pr = {
            ...peopleRepository,
        }
        const { data } = await pr.get(payload)
        commit(commitTypes.SET_PEOPLE, data)
        return data
    },
    async [actionTypes.LOAD_EXECUTIVES]({ commit }) {
        const ur = {
            ...usersRepository,
        }
        const { data } = await ur.getExecutives()
        commit(commitTypes.SET_EXECUTIVES, data)
        return data
    },
    async [actionTypes.LOAD_SUPERVISORS]({ commit }) {
        const ur = {
            ...usersRepository,
        }
        const { data } = await ur.getSupervisors()
        commit(commitTypes.SET_SUPERVISORS, data)
        return data
    },
    async [actionTypes.LOAD_ARLS]({ commit }) {
        const ar = {
            ...arlsRepository,
        }
        const { data } = await ar.index()
        commit(commitTypes.SET_ARLS, data)
    },
}

const loaded = (state, key) => !!state[key] && !!state[key].length
